import ChooseSetupType from "./ChooseSetupType.jsx";
import SetupNotFound from "./SetupNotFound.jsx";
import Complete from "./Complete.jsx";
import PreferredDomain from "./PreferredDomain.jsx";
import CurrentBlogDomain from "./CurrentBlogDomain.jsx";
import CurrentBlogLogin from "./CurrentBlogLogin.jsx";
import Confirm from "./Confirm.jsx";
import UpdateStart from "./UpdateStart.jsx";

export default {
  ChooseSetupType,
  SetupNotFound,
  CurrentBlogDomain,
  CurrentBlogLogin,
  PreferredDomain,
  Complete,
  Confirm,
  UpdateStart,
};
